// Needed to support async await
import 'regenerator-runtime/runtime'
import App from './App'
import render from 'commons/js/util/render'
import { init } from 'commons/js/util/reporter'

init()
const element = document.querySelector('.js-contact-form')
const fields = JSON.parse(element.dataset.fields)
const source = element.dataset.source
const sitekey = element.dataset.sitekey

render({ App, element, props: { fields, source, sitekey } })
